// extracted by mini-css-extract-plugin
export default {"loader":"eZBAwxmufy4NhnOLWo5Z","load7":"M1G3CCmEBG9MxCgQ25En"};